// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"a9e209e9","453":"eabe0536"}[chunkId] + ".chunk.js";
};